/* Collection navigation, wishlist, and native cart-drawer interactions. */
if (!customElements.get('rudraksha-collection-cards')) {
  customElements.define(
    'rudraksha-collection-cards',
    class RudrakshaCollectionCards extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.querySelectorAll('[data-rcc-product-form]').forEach((form) => {
          const button = form.querySelector('button[type="submit"]');
          if (button && document.querySelector('cart-drawer')) button.setAttribute('aria-haspopup', 'dialog');
          form.addEventListener('submit', (event) => this.addToCart(event, form));
        });

        this.wishlistStatus = this.querySelector('[data-rcc-wishlist-status]');
        this.querySelectorAll('[data-rcc-wishlist]').forEach((button) => {
          this.syncWishlistButton(button);
          button.addEventListener('click', (event) => this.toggleWishlist(event, button));
        });
      }

      getWishlistHandles() {
        try {
          return (localStorage.getItem('shopify-wishlist') || '')
            .split(',')
            .map((handle) => handle.trim())
            .filter(Boolean);
        } catch (error) {
          return [];
        }
      }

      setWishlistHandles(handles) {
        try {
          if (handles.length) localStorage.setItem('shopify-wishlist', handles.join(','));
          else localStorage.removeItem('shopify-wishlist');
        } catch (error) {
          return false;
        }
        return true;
      }

      syncWishlistButton(button, handles = this.getWishlistHandles()) {
        const handle = button.dataset.productHandle;
        const productTitle = button.dataset.productTitle || 'Product';
        const isActive = Boolean(handle && handles.includes(handle));
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
        button.setAttribute('aria-label', `${isActive ? 'Remove' : 'Add'} ${productTitle} ${isActive ? 'from' : 'to'} wishlist`);
      }

      toggleWishlist(event, button) {
        event.preventDefault();
        event.stopPropagation();
        if (button.disabled || !button.dataset.productHandle) return;

        const handle = button.dataset.productHandle;
        const title = button.dataset.productTitle || 'Product';
        const handles = this.getWishlistHandles();
        const existingIndex = handles.indexOf(handle);
        const wasAdded = existingIndex === -1;

        if (wasAdded) handles.push(handle);
        else handles.splice(existingIndex, 1);
        if (!this.setWishlistHandles(handles)) return;

        document.querySelectorAll(`[data-rcc-wishlist][data-product-handle="${CSS.escape(handle)}"]`).forEach((item) => this.syncWishlistButton(item, handles));
        if (this.wishlistStatus) this.wishlistStatus.textContent = `${title} ${wasAdded ? 'added to' : 'removed from'} your wishlist.`;
        document.dispatchEvent(new CustomEvent('rudraksha:wishlist-updated', { detail: { count: handles.length } }));
      }

      async addToCart(event, form) {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const label = form.querySelector('[data-button-label]');
        const error = form.querySelector('.rudraksha-collection-cards__error');
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        const originalLabel = label?.textContent || '';
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-loading');
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const formData = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
        }

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || 'Unable to add this product.');

          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(state);
          } else {
            window.location.assign(window.routes?.cart_url || '/cart');
            return;
          }

          if (label) label.textContent = 'Added';
          window.setTimeout(() => {
            if (label) label.textContent = originalLabel;
          }, 1400);
        } catch (exception) {
          if (error) {
            error.textContent = exception.message;
            error.hidden = false;
          }
        } finally {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-disabled');
        }
      }
    }
  );
}
